import "./Header.css"

export default function Header() {
  return (
    <header className="header">
      <h1 className="header-title">Gen-Z Teacher</h1>
      <p className="header-subtitle">Turn boring study material into lit Gen-Z explanations, no cap fr fr</p>
    </header>
  )
}
